import React, { Component } from "react";
import firebase from "@firebase/app";
import "@firebase/firestore";

class ScheduleCSV extends Component {
  constructor(props) {
    super(props);

    this.state = {
      matches: null,
      error: null,
    };
  }

  componentDidMount() {
    const firestore = firebase.firestore();
    const matchesRef = firestore
      .collection("seasons")
      .doc("2020-summer")
      .collection("matches")
      .orderBy("id", "asc");

    let matches = [];

    matchesRef
      .get()
      .then((docs) => {
        docs.forEach((doc) => {
          matches.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        this.setState({ matches });
      })
      .catch((error) => {
        this.setState({ error });
      });
  }

  render() {
    const { matches, error } = this.state;

    console.log(matches);

    if (!matches) {
      return <p>Loading...</p>;
    }

    if (error) {
      return <p>ERROR: {error}</p>;
    }

    if (!matches.length) {
      return <p>No matches to show</p>;
    }

    return (
      <div className="schedule-csv">
        <pre>
          <span>id,week,type,arena,team1,team2,timestamp</span>
          <br />

          {matches.map((match) => (
            <span>
              <span>
                {match.id},{match.week},{match.type},{match.arena},
                {match.teams.home.id},{match.teams.away.id},{match.date.seconds}
              </span>
              <br />
            </span>
          ))}
        </pre>
      </div>
    );
  }
}

export default ScheduleCSV;



// WEBPACK FOOTER //
// ./src/pages/schedule-csv/schedule-csv.js